import { BaseService } from "../BaseService";
import { SystemUserBaseService } from "./SystemUserBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { SystemUserModel } from "../../models/api/SystemUserModel";
import { SystemUserFindResultModel } from "../../models/api/SystemUserFindResultModel";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class SystemUserService extends SystemUserBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

}
